<script>

	import './style.scss'

	export default {
		name: 'success-stories',
	}

</script>

<template>
  <div>
    <div class='success-stories'>
      <header>
        Success Stories
      </header>
      <div class='testimonial-container'>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/eric.jpeg'>
          <div class='company'>
            <span class='name'>Eric</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/google.svg' class='google' />
          </div>
          <p>
          <strong>I landed my job at Google after regularly doing problems from the
            mailing list.</strong> I’ve taken algorithms courses and read through the
            Cracking the Coding Interview but I was never able to pass the
            interview until now!
          </p>
        </div>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/shubham.jpeg'>
          <div class='company'>
            <span class='name'>Shubham</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/microsoft.svg' class='microsoft' />
          </div>
          <p>
          I got an offer from Microsoft thanks to you guys! <strong>For the record, Daily
            Coding Problem is an awesome way to practice for coding interviews.</strong>
            Getting a question every day in my inbox was the motivation I needed
            to practice. Thanks again!
          </p>
        </div>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/eileen.jpeg'>
          <div class='company'>
            <span class='name'>Eileen</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/amazon.svg' class='amazon' />
          </div>
          <p>
          I got <strong>offers for internships at Amazon and Apple</strong>! Thanks for the great resource — I loved the questions!
          </p>
        </div>
      </div>
    </div>
    <div class='success-stories'>
        <div class='testimonial-container'>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/claudio.jpeg'>
          <div class='company'>
            <span class='name'>Claudio</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/airbnb.svg' class='airbnb' />
          </div>
          <p>
          I got the Airbnb offer! <strong>I loved the questions and they were extremely
            helpful for a great price!</strong>
          </p>
        </div>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/evan.jpg'>
          <div class='company'>
            <span class='name'>Evan</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/uber.svg' class='uber' />
          </div>
          <p>
						I'm thrilled to tell you that I had my on-site interview with Uber
            and I got an offer! This is precisely the offer I wanted, and <strong>it wouldn't
              have been possible without DCP!</strong>
          </p>
        </div>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/phil.jpeg'>
          <div class='company'>
            <span class='name'>Phil</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/dropbox.svg' class='dropbox' />
          </div>
          <p>
          <strong>Daily Coding Problem is amazing.</strong> It was a huge help to me while preparing for interviews, and thanks to it, I got an offer at Dropbox.
          </p>
        </div>
      </div>
    </div>
    <div class='success-stories'>
        <div class='testimonial-container'>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/calvin.jpeg'>
          <div class='company'>
            <span class='name'>Calvin</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/facebook.svg' class='facebook' />
          </div>
          <p>
          I got an offer at Facebook thanks to Daily Coding Problem! <strong>I recommend it to all my friends looking for a job</strong>.
          </p>
        </div>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/owen.jpeg'>
          <div class='company'>
            <span class='name'>Owen</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/google.svg' class='google' />
          </div>
          <p>
          I was able to successfully land a job at Google. I used the service for ~100 problems and <strong>it definitely made me a better developer and problem solver in general</strong>!
          </p>
        </div>
        <div class='testimonial'>
          <img class='avatar' src='~@/assets/success-stories/donnie.jpeg'>
          <div class='company'>
            <span class='name'>Donnie</span>
            <span class='slash'>+</span>
            <img src='~@/assets/svg/companies/amazon.svg' class='amazon' />
          </div>
          <p>
            After being in the mailing list for just 3 months I was able to
            receive a Software Engineer offer at Amazon. <strong>I highly recommend it
            to people who want to put in just a few months of extra effort to pass
            hard interviews.</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/SuccessStories/SuccessStories.vue